<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row v-if="tstatus == true">
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout
            :headertext="$t('Manufacturer.ManufacturerMaster.List')"
            :contenttext="
              $t('Manufacturer.ManufacturerMaster.TableHeaderContent')
            "
          >
          </Headerlayout>
        </b-col>
      </b-row>

      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="List.length === 0 && !loading"
                eheader="Manufacturer Master"
                econtent="Manufacturer Master"
                eimg="/src/assets/Img/icons/manufacturermaster.svg"
                @createNew="IsAdd"
              />
              <div class="table-width-80">
                <Tableview
                  v-if="List.length != 0"
                  :value="List"
                  :paginator="true"
                  class="p-datatable-gridlines"
                  showGridlines
                  :rows="10"
                  :rowHover="true"
                  filterDisplay="menu"
                  :loading="loading1"
                  responsiveLayout="scroll"
                  :columns="headers"
                  :globalFilterFields="globalFilterFields"
                  :filters="filters"
                  selectionMode="single"
                  @row-click="RowClick"
                  :exceldownload="true"
                >
                  <template v-slot:Add>
                    <span class="add">
                      <!-- <AddButton @click="IsCreate()" :btnname=" $t('btn.plusaddnew')" /> -->
                      <AddButton
                        @click="IsAdd"
                        :btnname="$t('btn.plusaddnew')"
                        class="float-rights my-3"
                      ></AddButton>
                    </span>
                  </template>
                  <template v-slot:exceldownload>
                    <ExportOption
                      @ExportExcel="ExportExcel"
                      @ExportPDF="ExportPDF"
                      :ExportList="ExportList"
                      PageName="Manufacturer Master"
                      :ExportOption="ExportOption"
                      class="ms-2"
                      :HideAndShow="true"
                    />
                  </template>
                  <template v-slot:Status="{ data }">
                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button
                        icon="pi pi-ellipsis-v"
                        class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)"
                      />
                    </span>
                  </template>
                </Tableview>
              </div>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="List.length === 0 && !loading"
                eheader="Manufacturer Master"
                econtent="Manufacturer Master"
                eimg="/src/assets/Img/icons/manufacturermaster.svg"
                @createNew="IsAdd"
              />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div
                      class="d-flex align-items-center justify-content-between gap-2"
                    >
                      <div>
                        <p class="light-name">{{ item.Code }}</p>
                        <p class="name">{{ item.Name }}</p>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <OrangeStatus
                            name="InActive"
                            v-if="item.IsActive == '0'"
                          />
                          <GreenStatus
                            name="Active"
                            v-if="item.IsActive == '1'"
                          />
                        </div>
                        <i
                          class="pi pi-ellipsis-v"
                          @click="toggle($event, item)"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <p class="light-name">
                        {{ item.ContactPerson ? item.ContactPerson : "" }}
                      </p>
                      <p class="light-name">
                        {{ item.Phone ? item.Phone : "" }}
                      </p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <Menu
      ref="menu"
      id="overlay_menu"
      :model="itemListed"
      @click=""
      :popup="true"
    />
    <EditConfirmation
      :Editmodel="Editmodel"
      @yes="IsEdit(dataEdit)"
      @no="Editmodel = false"
      :content="$t('confirmation.editcontent')"
    />
    <DeleteConfirmationVue
      :DeleteModel="Deletemodel"
      :content="content"
      @yes="IsDelete(dataEdit)"
      @no="Deletemodel = false"
    />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    <ActivatedSuccessfully :visible="popup.activatepop" @ok="closetrigger()" />
    <InActivatedSuccessfully
      :visible="popup.inactivepop"
      @ok="closetrigger()"
    />
    <Mapping
      :content="contentName"
      :visible="MappingPopUp"
      @ok="closeMapping()"
    />
    <!-- Commenly Used Components -->
  </div>
  <Toast />
</template>

<script lang="ts">
import { RouterLink, RouterView, useRouter } from "vue-router";
import { defineComponent, ref, h, onMounted, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Empty from "../../../../../../components/Masters/MasterEmpty.vue";
import axios from "axios";
import service from "../../../../Service/ManufacturerService";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    Empty,
    axios,

    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  props: {
    tstatus: {
      default: true,
      type: Boolean,
    },
  },
  setup() {
    debugger;
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const toast = useToast();
    const router = useRouter();
    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let loading = ref(false);
    let ExportOption = ref("");
    let ExportList = ref([]);
    let title = "ManufacturerMaster";
    const showDialog = ref(false);
    let List: any = ref([]);
    const rowFocus = ref(false);
    const dataEdit = ref();
    const menu = ref();
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    let Editvisible = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();

    const Deletemodel = ref(false);
    const deletepop = ref(false);
    let contentName = ref("");
    const MappingPopUp = ref(false);
    const ObjData = ref();
    const popup = ref({
      activatepop: false,
      inactivepop: false,
    });
    let content = ref("");

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [
      {
        header: t("Manufacturer.ManufacturerMaster.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("Manufacturer.ManufacturerMaster.Code"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("Manufacturer.ManufacturerMaster.Name"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },

      // {
      //   header: t('Manufacturer.ManufacturerMaster.ContactPerson'),
      //   field: "ContactPerson",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      // },
      // {
      //   header: t('Manufacturer.ManufacturerMaster.mobileno'),
      //   field: "Phone",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      // },
      {
        header: t("Manufacturer.ManufacturerMaster.Address"),
        field: "Address",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("Manufacturer.ManufacturerMaster.Status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ContactPerson: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      Phone: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const data_response = await service.getdata();
        let count = 0;
        if (usersData.Admin == 1) {
          data_response["result"] = data_response["result"]
            .filter((items) => items.HospitalId == usersData.OrganizationId)
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        } else {
          data_response["result"] = data_response["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId &&
                items.BranchId == usersData.BranchId
            )
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        }

        ExportList.value = data_response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;
      if (data.IsActive == 1) {
        Activevisible.value = false;
        InActivevisible.value = true;
        Editvisible.value = true;
      } else if (data.IsActive == 0) {
        Activevisible.value = true;
        InActivevisible.value = false;
        Editvisible.value = false;
      }
      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(ObjData);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(ObjData, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(ObjData, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(ObjData, 2);
            },
          },
        ],
      },
    ]);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);

      document.addEventListener("keydown", onKeyUp);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true
      ) {
        Editmodel.value = true;
      } else if (event.altKey && event.key == "n") {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (event.key == "d" && rowFocus.value == true) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopUp.value == true) {
        MappingPopUp.value = false;
        Deletemodel.value = false;
      }
    }

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
      dataEdit.value = event.data;
      router.push({
        path: "/ManufacturerMasterDetails",
        query: { id: event.data.Id },
      });
    }

    //Add New PopUp
    const IsAdd = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/ManufacturerMasterCreation",
          query: { OperationId: ObjOperationId.value.CreateId },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };
    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    function IsConfirmDel(data, status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = false;
        Deletemodel.value = true;
        Deletemodel.value = true;
        data.ActiveStatus = status;
        if (status == 1) {
          content.value = t("confirmation.activecontent");
        } else if (status == 2) {
          content.value = t("confirmation.inactivecontent");
        } else {
          content.value = t("confirmation.deletecontent");
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      popup.value.activatepop = false;
      popup.value.inactivepop = false;
    }

    // Map Popup-Close
    function closeMapping() {
      Deletemodel.value = false;
      MappingPopUp.value = false;
    }

    //Table List
    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        const data_response = await service.getdata();
        let count = 0;
        if (usersData.Admin == 1) {
          data_response["result"] = data_response["result"]
            .filter((items) => items.HospitalId == usersData.OrganizationId)
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        } else {
          data_response["result"] = data_response["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId &&
                items.BranchId == usersData.BranchId
            )
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        }

        List.value = data_response["result"];

        console.log(List.value);
        loading.value = false;
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    //Edit Click function
    async function IsEdit(data) {
      debugger;
      router.push({
        path: "/ManufacturerMasterCreation",
        query: {
          id: data.value.Id,
          OperationId: ObjOperationId.value.UpdateId,
        },
      });
    }

    //Row Delete
    async function IsDelete(data) {
      debugger;
      loading.value = true;
      const DelID = data.value.Id;
      try {
        let data_response: any = "";
        if (data.ActiveStatus == 0) {
          data_response = await service.Delete(DelID);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          data_response = await service.active(DelID, status);
        }

        console.log(data_response);
        let message = data_response["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (data_response["result"] != "False" && message == null) {
          contentName.value = data_response["result"];
          MappingPopUp.value = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            popup.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            popup.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    return {
      closeMapping,
      MappingPopUp,
      contentName,
      title,
      headers,
      filter,
      showmodalref,
      showpopModal: showmodalref,
      loading1,
      loading,
      List,
      IsDelete,
      filters,
      globalFilterFields,
      filteredColumns,
      IsShow,
      IsEdit,
      RowClick,
      dataEdit,
      Editmodel,
      IsAdd,
      onKeyUp,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      menu,
      toggle,
      itemListed,
      popup,
      content,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>

<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}
</style>
